import { createContext } from 'react'
import { IUseNetworkError } from 'Hooks/useNetworkError'

const NetworkErrorContext = createContext<IUseNetworkError>({
  error: false,
  updateError: () => {},
})

export default NetworkErrorContext
